// extracted by mini-css-extract-plugin
export var iframe = "video-module--iframe--d7159";
export var video = "video-module--video--888c7";
export var videoHomepage = "video-module--videoHomepage--001f6";